import { Loader2 } from 'lucide-react';
import { Modal } from '../../ui/Modal';
import { pillPrimary, pillSecondary } from '../../ui/pills';

/**
 * Confirmation de clôture (maquette 18c, « ConvivesValiderModal · confirmation · 400 ») : elle nomme ce
 * qui va se passer et sur combien de couverts la cuisine part. Derrière, le geste de l'appli ne change
 * pas : les réponses ferment, la liste se valide, les silencieux reçoivent le courriel « Clôture ».
 */
export function ConvivesCloturerModal({ reponses, silencieux, contraintes, closing, onConfirm, onClose }: {
    reponses: number;
    silencieux: number;
    contraintes: number;
    closing: boolean;
    onConfirm: () => Promise<void> | void;
    onClose: () => void;
}) {
    const lignes: [string, number, string][] = [
        ['Réponses transmises en cuisine', reponses, 'text-content'],
        ['Convives sans réponse', silencieux, 'text-state-warn'],
        ['Assiettes adaptées', contraintes, 'text-state-danger'],
    ];
    return (
        <Modal open onClose={onClose} size="sm" title="Clôturer la collecte"
            subtitle={<>Les convives ne peuvent plus répondre, le compte part en cuisine et le plan de table devient consultable en mode terrain.{silencieux > 0 ? ` ${silencieux === 1 ? 'Le silencieux ne sera pas compté' : `Les ${silencieux} silencieux ne seront pas comptés`}, et ${silencieux > 1 ? 'ils recevront' : 'il recevra'} le courriel « Clôture ».` : ''}</>}
            footer={
                <>
                    <button type="button" onClick={onClose} className={pillSecondary()} disabled={closing}>Annuler</button>
                    <button type="button" onClick={onConfirm} className={pillPrimary()} disabled={closing}>
                        {closing ? <Loader2 size={13} className="animate-spin" /> : null} Clôturer sur {reponses} couvert{reponses > 1 ? 's' : ''}
                    </button>
                </>
            }>
            <div className="space-y-2">
                {lignes.map(([k, v, cls]) => (
                    <div key={k} className="flex items-baseline justify-between gap-3.5">
                        <span className="text-[12.5px] text-content-muted">{k}</span>
                        <span className={`text-[13px] font-bold tabular-nums ${cls}`}>{v}</span>
                    </div>
                ))}
            </div>
        </Modal>
    );
}
